export const getTempPatientId = (id: string): string => {
  return `TEMP-${id}`;
};
